import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

export default ({ component }: { component: ReactNode}) => createPortal(
  component,
  global.document.getElementById('banner') as HTMLElement
);
